// @flow
import { handleResponseWithNon200Errors, makeGet } from './helpers';

type FetchCatalogAnnouncementsByCatalogIdParams = {
    catalogId: number,
    deployment: string,
    houseId: number,
};

type fetchCatalogAnnouncementsByAnnouncementIdParams = {
    announcementId: number,
    deployment: string,
};

export default {
    fetchCatalogAnnouncementsByAnnouncementId: ({
        announcementId,
        deployment,
    }: fetchCatalogAnnouncementsByAnnouncementIdParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ deployment, path: `<ANNOUNCEMENTS-API>announcements/${announcementId}` });
            request.end((err, response) => handleResponseWithNon200Errors({ err, reject, resolve, response }));
        }),
    fetchCatalogAnnouncementsByCatalogId: ({
        catalogId,
        deployment,
        houseId,
    }: FetchCatalogAnnouncementsByCatalogIdParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ deployment, path: '<ANNOUNCEMENTS-API>announcements' });
            request.query({ catalogId, houseId });
            request.end((err, response) => handleResponseWithNon200Errors({ err, reject, resolve, response }));
        }),
};
